import { ofType } from "redux-observable";
import { of } from "rxjs";
import { concat } from "rxjs";
import { mergeMap } from "rxjs/operators";
import normalize from "json-api-normalizer";
import { parseError } from "./lib";

import LocationService from "../services/locationService";

import {
  loadLocationsSuccess,
  loadLocationsFailure,
  LOAD_LOCATIONS_REQUEST_ACTION,
  SAVE_LOCATION_REQUEST_ACTION,
  saveLocationFailure,
  saveLocationSuccess,
  DELETE_LOCATION_REQUEST_ACTION,
  deleteLocationFailure,
  deleteLocationSuccess,
  LOAD_LOCATION_REQUEST_ACTION,
  loadLocationSuccess,
  loadLocationFailure,
  SAVE_LOCATION_SUCCESS_ACTION,
  SAVE_LOCATION_FAILURE_ACTION,
  saveLocationRequest,
  loadAccountRequest
} from "../ducks/data";
import {
  saveLocationFormSuccess,
  saveLocationFormFailure,
  SAVE_LOCATION_FORM_REQUEST_ACTION
} from "../ducks/location";
import { setActiveDialog } from "../ducks/app";

const _ = require("lodash");
export const loadLocationEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_LOCATION_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let locationService = new LocationService();
      return locationService
        .find(action.payload)
        .then(response => {
          return loadLocationSuccess(normalize(response.data));
        })
        .catch(error => {
          return loadLocationFailure(parseError(error));
        });
    })
  );

export const loadLocationsEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_LOCATIONS_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let locationService = new LocationService();
      return locationService
        .findAll(action.payload)
        .then(response => {
          return loadLocationsSuccess(normalize(response.data));
        })
        .catch(error => {
          return loadLocationsFailure(parseError(error));
        });
    })
  );

export const saveLocationFormRequestEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_LOCATION_FORM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      return of(saveLocationRequest(action.payload));
    })
  );

export const saveLocationFormSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_LOCATION_SUCCESS_ACTION.getType()),
    mergeMap(action => {
      const locations = action.payload.location;
      const location = locations.locations[Object.keys(locations.locations)[0]];
      return concat(
        of(saveLocationFormSuccess(locations)),
        of(loadAccountRequest(location.attributes.accountId)),
        of(setActiveDialog())
      );
    })
  );

export const saveLocationFormFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_LOCATION_FAILURE_ACTION.getType()),
    mergeMap(action => {
      // TODO: check result for validation failure or communication failure based on status
      return of(saveLocationFormFailure(action.payload));
    })
  );

export const saveLocationEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_LOCATION_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let location = action.payload;
      let service = new LocationService();
      return service
        .save(location)
        .then(response => {
          return saveLocationSuccess(normalize(response.data));
        })
        .catch(error => {
          return saveLocationFailure(parseError(error));
        });
    })
  );

export const deleteLocationEpic = (action$, state$) =>
  action$.pipe(
    ofType(DELETE_LOCATION_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new LocationService();
      return concat(
        service
          .archive(action.payload)
          .then(response => {
            return deleteLocationSuccess(action.payload);
          })
          .catch(error => {
            return deleteLocationFailure(parseError(error));
          }),
        of(setActiveDialog())
      );
    })
  );



// WEBPACK FOOTER //
// ./src/epics/locations.js